module.exports = __webpack_public_path__ + "media/img/pages/companies/vermogenszentrum-d24eca2058be596265a0c19bddd09668.jpg";